import { createEnv } from '@t3-oss/env-nextjs'
import { z } from 'zod'

export const env = createEnv({
  server: {
    NEXT_API_URI: z.string().min(1),
    AUTH_URL: z.string(),
    AUTH_SECRET: z.string().min(1),
    NEXT_TOKEN: z.string().min(1),
  },
  client: {
    NEXT_PUBLIC_TOKEN: z.string().min(1),
    NEXT_PUBLIC_URL_SPACE: z.string().min(1),
    NEXT_PUBLIC_URL_ACCOUNT: z.string().min(1),
  },
  shared: {
    NODE_ENV: z.enum(['development', 'production', 'test']),
    NEXT_PUBLIC_API_URI: z.string().min(1),
  },
  runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    NEXT_API_URI: process.env.NEXT_API_URI,
    AUTH_URL: process.env.AUTH_URL,
    NEXT_TOKEN: process.env.NEXT_TOKEN,
    AUTH_SECRET: process.env.AUTH_SECRET,
    NEXT_PUBLIC_TOKEN: process.env.NEXT_PUBLIC_TOKEN,
    NEXT_PUBLIC_API_URI: process.env.NEXT_PUBLIC_API_URI,
    NEXT_PUBLIC_URL_SPACE: process.env.NEXT_PUBLIC_URL_SPACE,
    NEXT_PUBLIC_URL_ACCOUNT: process.env.NEXT_PUBLIC_URL_ACCOUNT,
  },
})
